import React from 'react'
import PropTypes from 'prop-types'
import { compose, string } from 'common/helpers'
import { injectIntl } from 'sb-react-intl'

import Link from 'components/ui/Link/Link'
import ImageWithPlaceholderFallback from 'components/ui/ImageWithPlaceholderFallback/ImageWithPlaceholderFallback'
import Message from 'components/text/Message/Message'

import messages from './messages.js'
import s from './ProductResult.scss'


const getSafeProduct = (product, intl) => {
  const newProduct = { ...product }

  Object.keys(newProduct).forEach((key) => {
    if (typeof newProduct[key] === 'string') {
      newProduct[key] = string.trimHtml(newProduct[key])
    }
  })

  return newProduct
}

const ProductResult = ({ index, product: { available, brand, img, name, url }, product, onClick, onAdd, intl }) => {
  const safeProduct = getSafeProduct(product)

  return (
    <div className={s.product}>
      <Link
        className={s.link}
        to={url}
        onClick={() => onClick({
          product: getSafeProduct(product),
          position: index + 1,
        })}
        blackToBrandColor
        aria-label={intl.formatMessage(messages.goTo, { product: `${safeProduct.brand} + ${safeProduct.name}` })}
      >
        <ImageWithPlaceholderFallback className={s.image} src={img} w={50} />
        <div className={s.text}>
          <Message tag="div" className={s.name} text={name} html />
          <Message tag="div" className={s.brand} text={brand} html />
        </div>
      </Link>
      { available && (
        <button
          className={s.addButton}
          type="button"
          onClick={() => onAdd({ product: safeProduct })}
          aria-label={intl.formatMessage(messages.addTo, { product: `${safeProduct.brand} + ${safeProduct.name}` })}
        >
          <svg viewBox="0 0 26 26" width={26} height={26}>
            <circle fill="currentColor" cx="13" cy="13" r="13" />
            <path d="M12 14H7v-2h5V7h2v5h5v2h-5v5h-2v-5z" fill="#FFF" />
          </svg>
        </button>
      )}
    </div>
  )
}

ProductResult.propTypes = {
  index: PropTypes.number,
  product: PropTypes.shape({
    id: PropTypes.number.isRequired,
    available: PropTypes.bool.isRequired,
    bestseller: PropTypes.bool.isRequired,
    brand: PropTypes.string.isRequired,
    gender: PropTypes.oneOf([ 'male', 'female', 'unisex' ]).isRequired,
    img: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
    url: PropTypes.string.isRequired,
  }).isRequired,
  onClick: PropTypes.func,
  onAdd: PropTypes.func,

  intl: PropTypes.object, // @injectIntl
}


export default compose(
  injectIntl,
)(ProductResult)
